import React from "react";
import download_icon from "../../../../assets/vw/svg/download-white.svg";
import eliminar_icon from "../../../../assets/vw/svg/eliminar-white.svg";
import preview_icon from "../../../../assets/vw/svg/eye.svg";
import copy_icon from "../../../../assets/vw/svg/copy-icon.svg";
import editar_icon from "../../../../assets/vw/svg/editar_blanco.svg";
import mover_icon from "../../../../assets/vw/svg/mover-blanco.svg";
import menu_opc from "../../../../assets/vw/svg/menu-opciones.svg";
import { FileTypeIcon, getLibraryItemName, isImageFile } from "../fileIcons";

const formatDate = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleDateString("es-MX");
};

const formatBytes = (bytes) => {
  if (bytes === undefined || bytes === null) return "";
  if (bytes === 0) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB"];
  const sizeIndex = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, sizeIndex);

  return `${size.toFixed(sizeIndex === 0 ? 0 : 1)} ${units[sizeIndex]}`;
};

const getActionTarget = (archivo = {}) => archivo.__isPrefix ? archivo : archivo.__source || archivo;

const Cards = ({
  page,
  onRowClick = () => {},
  onDescargar = () => {},
  onEliminar = () => {},
  onMover = () => {},
  onCopiar = () => {},
  onRenombrar = () => {},
  onPreview = () => {},
  currentPrefix = "",
}) => {
  return (
    <div className="grid__view libreria-cards__view">
      <div className="libreria-grid-view row">
        {page.map((archivo, index) => (
          <div className="col-3 mb-3" key={index}>
            <div
              className="card_grid libreria-card"
              onClick={() => onRowClick(archivo.original)}
            >
              <div className="container_id">{index + 1}</div>
              <div className="libreria-card-content">
                <div className="libreria-card-main">
                  <FileTypeIcon item={archivo.original} />
                  <div>
                    <div className="title_card libreria-card-title" title={getLibraryItemName(archivo.original) || "Archivo"}>
                      {getLibraryItemName(archivo.original) || "Archivo"}
                    </div>
                    <div className="url_description libreria-card-description">
                      {formatDate(archivo.original.LastModified)}
                    </div>
                    <div className="url_description libreria-card-description">
                      {formatBytes(archivo.original.Size)}
                    </div>
                  </div>
                </div>
                <div className="libreria-card-footer">
                  <div className="d-flex align-items-center">
                    <button
                      className="button_icon-vw"
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();
                        onDescargar(getActionTarget(archivo.original));
                      }}
                      data-track-click="btn-descargar-archivo-card"
                    >
                      <img src={download_icon} alt="descargar" />
                    </button>
                    <button
                      className="button_icon-vw ml-2"
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();
                        onEliminar(getActionTarget(archivo.original));
                      }}
                      data-track-click="btn-eliminar-archivo-card"
                    >
                      <img src={eliminar_icon} alt="eliminar" />
                    </button>
                    {isImageFile(archivo.original) && (
                      <button
                        className="button_icon-vw ml-2"
                        type="button"
                        onClick={(event) => {
                          event.stopPropagation();
                          onPreview(getActionTarget(archivo.original));
                        }}
                        data-track-click="btn-vista-previa-archivo-card"
                      >
                        <img src={preview_icon} alt="vista previa" />
                      </button>
                    )}
                    {currentPrefix && (
                      <button
                        className="button_icon-vw ml-2"
                        type="button"
                        onClick={(event) => {
                          event.stopPropagation();
                          onCopiar(getActionTarget(archivo.original));
                        }}
                        data-track-click="btn-copiar-archivo-card"
                      >
                        <img src={copy_icon} alt="copiar" />
                      </button>
                    )}
                  </div>
                  <div className="tooltip_vw" onClick={(event) => event.stopPropagation()}>
                    <button className="button_icon-vw" type="button">
                      <img src={menu_opc} alt="menu" />
                    </button>
                    <div className="tooltiptext p-2 ">
                      <button
                        className="button_icon-vw"
                        type="button"
                        onClick={(event) => {
                          event.stopPropagation();
                          onMover(getActionTarget(archivo.original));
                        }}
                        data-track-click="btn-mover-archivo-card-tooltip"
                      >
                        <div className="aling-icon">
                          <img src={mover_icon} alt="mover" className="px-2" />
                          Mover a
                        </div>
                      </button>
                      <button
                        className="button_icon-vw"
                        type="button"
                        onClick={(event) => {
                          event.stopPropagation();
                          onRenombrar(getActionTarget(archivo.original));
                        }}
                        data-track-click="btn-renombrar-archivo-card-tooltip"
                      >
                        <div className="aling-icon">
                          <img src={editar_icon} alt="renombrar" className="px-2" />
                          Renombrar
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cards;
